import {NgClass, NgOptimizedImage} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {IonAvatar} from '@ionic/angular/standalone';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl' | number;
export type AvatarStatus = 'online' | 'offline' | 'away' | 'busy';

@Component({
	selector: 'app-avatar',
	standalone: true,
	templateUrl: './app-avatar.component.html',
	styleUrls: ['./app-avatar.component.scss'],
	imports: [IonAvatar, NgClass, NgOptimizedImage],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppAvatarComponent {
	src = input<string | null>(null);
	alt = input<string>('User avatar');
	initials = input<string | null>(null);
	size = input<AvatarSize>('md');
	status = input<AvatarStatus>('offline');
	showStatus = input(false);
	priority = input(false);

	protected readonly resolvedSize = computed(() => {
		const value = this.size();
		if (typeof value === 'number') {
			return Math.max(24, value);
		}
		switch (value) {
			case 'sm':
				return 32;
			case 'lg':
				return 56;
			case 'xl':
				return 72;
			case 'md':
			default:
				return 40;
		}
	});
}
